import { FC, ReactNode } from 'react'
import { Helmet as HelmetAsync } from 'react-helmet-async'

type HelmetType = FC<{ children: ReactNode }>

const Helmet = HelmetAsync as unknown as HelmetType

export default Helmet
export { Helmet }
